import { useState } from "react";
import SearchProductCard from "../../../Common/Cards/SearchProductCard/SearchProductCard";

const tabs = ["foods", "kitchens", "categories"];

const SearchDropdown = ({
  fullResult,
  setShowDropdown,
  loading
}) => {
  const [activeTab, setActiveTab] = useState("foods");
  const result = fullResult?.[activeTab] || [];

  return (
    <div className="ownfood-search-dropdown">
      <div className="ownfood-search-tabs">
        {tabs?.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={activeTab === tab ? "ownfood-tab active" : "ownfood-tab"}
          >
            <span className="text-capitalize">{tab}</span>
          </button>
        ))}
      </div>

      <div className="ownfood-search-results">
        {result?.length > 0 ? (
          result?.map((item, i) => (
            <SearchProductCard
              setShowDropdown={setShowDropdown}
              key={item._id || i}
              item={item}
              tab={activeTab}
            />
          ))
        ) : loading ? (
          <p className="ownfood-no-result">Loading...</p>
        ) : (
          <p className="ownfood-no-result">No items found</p>
        )}
      </div>

      <div className="ownfood-search-footer">
        <button className="ownfood-see-all-btn">See all results</button>
      </div>
    </div>
  );
};

export default SearchDropdown;
